import {peakAlert} from "../../../PeakDialog.js";
import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();

export class ZIDXAccountSiteAPI implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountSiteAPIContainer";
    }
    render(){
        let self=this;
        $("#zidxSiteIDCopy", this.zidx.peakidxShadowRoot).on("click", function(e:JQuery.ClickEvent){
            e.preventDefault();
            let input=self.zidx.peakidxShadowRoot.getElementById("zidxSiteIdInput")!;
            $(input).trigger("select");
            try {
                let successful = document.execCommand('copy');
            } catch (err) {
                peakAlert('Copy to clipboard is disabled by your browser.');
            }
        });
        $("#zidxSiteURLCopy", this.zidx.peakidxShadowRoot).on("click", function(e:JQuery.ClickEvent){
            e.preventDefault();
            let input=self.zidx.peakidxShadowRoot.getElementById("zidxSiteURLInput")!;
            $(input).trigger("select");
            try {
                let successful = document.execCommand('copy');
            } catch (err) {
                peakAlert('Copy to clipboard is disabled by your browser.');
            }
        });
        $("#zidxHiddenAPIKeyCopy", this.zidx.peakidxShadowRoot).on("click", function(e:JQuery.ClickEvent){
            e.preventDefault();
            let input=self.zidx.peakidxShadowRoot.getElementById("zidxHiddenAPIKeyInput")!;
            $(input).trigger("select");
            try {
                let successful = document.execCommand('copy');
            } catch (err) {
                peakAlert('Copy to clipboard is disabled by your browser.');
            }
        });
    }
}